import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from "../../../middlewares/api/actions";
import {
  getArtefactFromSdmxJsonStructure,
  getSdmxStructuresFromSdmxJson,
  SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY
} from "../../../utils/sdmxJson";
import {
  HIERARCHICAL_CODELISTS_AGENCIES_READ,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SHOW,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SUBMIT,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE,
  HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ,
  HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ,
  HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE
} from "./actions";
import _ from "lodash";
import {getCurrentNodeConfig} from "../../../middlewares/current-node-config/middleware";
import {getCustomIsPresentationalFromAnnotations} from "../../../utils/referenceMetadata";
import {getCurrentUserPermissions} from "../../../middlewares/current-user-permissions/middleware";
import { LOGIN_OPTION_ACCOUNT } from "../../../components/artefact-export-form";

const hierarchicalCodelistsReducer = (
  state = {
    hierarchicalCodelists: null,
    isVisible: false,
    hierarchicalCodelistTriplet: null,
    hierarchicalCodelist: null,
    agencies: null,
    allAgencies: null,
    downloadHierarchicalCodelistTriplets: null,
    downloadHierarchicalCodelistLang: null,
    downloadHierarchicalCodelistParams: null,
    parentsAndChildren: null,
    cloneDestTriplet: null,
    hierarchicalCodelistExportSourceTriplet: null,
    hierarchicalCodelistExportDestination: null,
    hierarchicalCodelistExportReport: null
  },
  action
) => {
  switch (action.type) {
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SHOW:
      return {
        ...state,
        isVisible: true,
        hierarchicalCodelistTriplet: action.artefactTriplet
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_CHANGE:
      const hierarchicalCodelist = _.cloneDeep(state.hierarchicalCodelist);

      const customizer = (_, src, key) => {
        if (key === "annotations")
          return src;
        else {
          return undefined
        }
      };

      return {
        ...state,
        hierarchicalCodelist: _.mergeWith(hierarchicalCodelist, action.fields, customizer)
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_HIDE:
      return {
        ...state,
        isVisible: false,
        hierarchicalCodelist: null,
        hierarchicalCodelistTriplet: null,
        agencies: null
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_SHOW:
      return {
        ...state,
        downloadHierarchicalCodelistTriplets: action.artefactTriplets,
        downloadHierarchicalCodelistLang: action.lang,
        downloadHierarchicalCodelistParams: {
          format: null,
          references: false,
          compression: false,
          csvSeparator: ";",
          csvDelimiter: null,
          csvLanguage: null
        },
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_HIDE:
      return {
        ...state,
        downloadHierarchicalCodelistTriplets: null,
        downloadHierarchicalCodelistLang: null,
        downloadHierarchicalCodelistParams: null
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD_CHANGE:
      const downloadHierarchicalCodelistParams = _.cloneDeep(state.downloadHierarchicalCodelistParams);
      return {
        ...state,
        downloadHierarchicalCodelistParams: _.merge(downloadHierarchicalCodelistParams, action.fields)
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_HIDE:
      return {
        ...state,
        parentsAndChildren: null
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SHOW:
      const srcVersionArr = action.srcTriplet.version.split(".");
      const destVersionArr = srcVersionArr.map((num, index) =>
        index === srcVersionArr.length - 1
          ? Number(num) + 1
          : num
      );

      return {
        ...state,
        cloneDestTriplet: {
          ...action.srcTriplet,
          version: destVersionArr.join(".")
        },
        hierarchicalCodelistTriplet: state.hierarchicalCodelistTriplet ? state.hierarchicalCodelistTriplet : action.srcTriplet,
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_HIDE:
      return {
        ...state,
        cloneDestTriplet: null,
        hierarchicalCodelist: state.isVisible ? state.hierarchicalCodelist : null,
        hierarchicalCodelistTriplet: state.isVisible ? state.hierarchicalCodelistTriplet : null,
        agencies: state.isVisible ? state.agencies : null,
        allAgencies: state.isVisible ? state.allAgencies : null
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_CHANGE:

      const cloneDestTriplet = _.cloneDeep(state.cloneDestTriplet);

      return {
        ...state,
        cloneDestTriplet: _.merge(cloneDestTriplet, action.fields)
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SHOW:
      return {
        ...state,
        hierarchicalCodelistExportSourceTriplet: action.sourceTriplet,
        hierarchicalCodelistExportDestination: {
          endpoint: null,
          username: null,
          password: null,
          id: action.sourceTriplet.id,
          agencyID: action.sourceTriplet.agencyID,
          version: action.sourceTriplet.version,
          loginOption: LOGIN_OPTION_ACCOUNT,
          providerLoginCode: null
        }
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_HIDE:
      return {
        ...state,
        hierarchicalCodelistExportSourceTriplet: null,
        hierarchicalCodelistExportDestination: null,
        agencies: state.isVisible ? state.agencies : null,
        allAgencies: state.isVisible ? state.allAgencies : null
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_CHANGE:

      const hierarchicalCodelistExportDestination = _.cloneDeep(state.hierarchicalCodelistExportDestination);
      _.merge(hierarchicalCodelistExportDestination, action.fields);

      return {
        ...state,
        hierarchicalCodelistExportDestination
      };
    case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_REPORT_HIDE:
      return {
        ...state,
        hierarchicalCodelistExportReport: null
      };
    case REQUEST_START:
      switch (action.label) {
        case HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ:
          return {
            ...state,
            hierarchicalCodelists: null
          };
        default:
          return state;
      }
    case REQUEST_SUCCESS:
      switch (action.label) {
        case HIERARCHICAL_CODELISTS_LIST_HIERARCHICAL_CODELISTS_READ:
          return {
            ...state,
            hierarchicalCodelists: getSdmxStructuresFromSdmxJson(action.response).map(artefact =>
              getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
          };
        case HIERARCHICAL_CODELISTS_AGENCIES_READ:
          return {
            ...state,
            agencies: _.pickBy(action.response, (_, agencyID) => !action.allowedAgencies || action.allowedAgencies.includes(agencyID)),
            allAgencies: action.response,
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_READ:

          const userPermissions = getCurrentUserPermissions(action);
          const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
            ? () => false
            : undefined;

          const hierarchicalCodelist = getArtefactFromSdmxJsonStructure(
            getSdmxStructuresFromSdmxJson(action.response, SDMX_JSON_HIERARCHICAL_CODELIST_LIST_KEY)[0],
            getCurrentNodeConfig(action).annotations,
            customNoneIsAutoAnnotation
          );

          return {
            ...state,
            hierarchicalCodelist: {
              ...hierarchicalCodelist,
              customIsPresentational: getCustomIsPresentationalFromAnnotations(hierarchicalCodelist, getCurrentNodeConfig(action).annotations)
            }
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DETAIL_SUBMIT:
          return {
            ...state,
            hierarchicalCodelist: null,
            hierarchicalCodelists: null
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DELETE:
          return {
            ...state,
            hierarchicalCodelists: null
          };
        case HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE:
          return {
            ...state,
            hierarchicalCodelists: null
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_DOWNLOAD:
          return {
            ...state,
            downloadHierarchicalCodelistTriplets: null,
            downloadHierarchicalCodelistLang: null,
            downloadHierarchicalCodelistParams: null
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_PARENTS_AND_CHILDREN_READ:
          return {
            ...state,
            parentsAndChildren: action.response
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_EXPORT_SUBMIT:
          return {
            ...state,
            hierarchicalCodelistExportSourceTriplet: null,
            hierarchicalCodelistExportDestination: null,
            hierarchicalCodelistExportReport: action.response.itemsMessage,
            agencies: state.isVisible ? state.agencies : null,
            allAgencies: state.isVisible ? state.allAgencies : null
          };
        case HIERARCHICAL_CODELISTS_HIERARCHICAL_CODELIST_CLONE_SUBMIT:
          return {
            ...state,
            hierarchicalCodelists: null,
            cloneDestTriplet: null,
            hierarchicalCodelistTriplet: state.isVisible ? state.hierarchicalCodelistTriplet : null,
            hierarchicalCodelist: state.isVisible ? state.hierarchicalCodelist : null,
            agencies: state.isVisible ? state.agencies : null,
            allAgencies: state.isVisible ? state.allAgencies : null
          };
        default:
          return state;
      }
    case REQUEST_ERROR:
      switch (action.label) {
        case HIERARCHICAL_CODELISTS_SELECTED_HIERARCHICAL_CODELISTS_DELETE:
          return {
            ...state,
            hierarchicalCodelists: null
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

export default hierarchicalCodelistsReducer;



// WEBPACK FOOTER //
// ./src/scenes/meta-manager/hierarchical-codelists/reducer.js